<template>
  <v-card height="100%" width="100%" color="transparent" flat>
    <div class="d-flex justify-space-between">
      <div class="survey-category-border"></div>
      <div class="d-flex survey-category">
        <span style="font-size: 32px" class="mr-3">Family</span>
        <v-icon large right color="secondary">mdi-home</v-icon>
      </div>
    </div>
    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
      <v-card flat color="transparent">
        <v-card-title class="font-weight-bold q-message">{{ `${qNumber ? qNumber + '. ' : ''} ${qMessage}` }}</v-card-title>
        <v-container class="pt-2 pl-10">
          <v-row>
            <v-col class="title d-flex align-center" cols="5">
              <div>{{ `현재 ~ 퇴직시점 (${getExit[0].age}세)` }}</div>
            </v-col>
            <v-col cols="7" class="d-flex align-center">
              <v-text-field dense single-line class="mx-5" counter v-model="answer[0]" :rules="getRule('text')" placeholder="이 단계의 이슈 입력" @keyup.enter="confirm" />
            </v-col>
          </v-row>
          <v-row>
            <v-col class="title d-flex align-center" cols="5">
              <div>{{ `퇴직 이후 ~ 국민연금 수령시점(${getPensionAge()}세)` }}</div>
            </v-col>
            <v-col cols="7" class="d-flex align-center">
              <v-text-field dense single-line class="mx-5" counter v-model="answer[1]" :rules="getRule('text')" placeholder="이 단계의 이슈 입력" @keyup.enter="confirm" />
            </v-col>
          </v-row>
          <v-row>
            <v-col class="title d-flex align-center" cols="5">
              <div>{{ `국민연금 수령 이후` }}</div>
            </v-col>
            <v-col cols="7" class="d-flex align-center">
              <v-text-field dense single-line class="mx-5" counter v-model="answer[2]" :rules="getRule('text')" placeholder="이 단계의 이슈 입력" @keyup.enter="confirm" />
            </v-col>
          </v-row>
          <!-- <v-row v-for="(q, i) in getExit" :key="q.name">
            <v-col class="title d-flex align-center" cols="5">
              <div>{{ `[EXIT-${i + 1}] ${q.name}:  ${q.age}세 (${q.year})이후` }}</div>
            </v-col>
            <v-col cols="7" class="d-flex align-center">
              <v-text-field dense single-line class="mx-5" counter v-model="answer[i + 1]" :rules="getRule('text')" placeholder="이 단계의 이슈 입력`" @keyup.enter="confirm" />
            </v-col>
          </v-row> -->
          <v-row>
            <v-col class="title d-flex align-center" cols="5">
              <div>{{ `그외 기타 재무이슈는? ` }}</div>
            </v-col>
            <v-col cols="7" class="d-flex align-center">
              <v-text-field dense single-line class="mx-5" counter v-model="answer[3]" :rules="getRule('text')" placeholder="이 단계의 이슈 입력" @keyup.enter="confirm" />
            </v-col>
          </v-row>
        </v-container>
      </v-card>
      <v-card-actions>
        <v-btn color="#5878b8" :disabled="!valid && this.isSkipped.filter((k) => k).length === 0" width="100" class="headline white--text" @click="confirm">
          확인
          <v-icon right>mdi-check</v-icon>
        </v-btn>
        <!-- <v-btn text color="grey" class="title" v-if="valid">
          Enter 키를 눌러주세요
          <v-icon>mdi-keyboard-return</v-icon>
        </v-btn> -->
      </v-card-actions>
    </v-form>
  </v-card>
</template>
<script>
import { mapMutations, mapState, mapGetters, mapActions } from 'vuex'
import _ from 'lodash'
export default {
  props: {
    qNumber: {
      type: String,
      default: '',
    },
    qMessage: {
      type: String,
      default: '',
    },
  },
  mounted() {
    const ans = (this['life'] || {})['라이프-생애이슈']
    if (ans) {
      // console.log(ans)
      const ansValueList = ans.value.map(({ value }) => value)
      const ansIsSkippedList = ans.value.map(({ isSkipped }) => isSkipped)
      this.answer = ansValueList
      this.isCompleted = true
    }
  },
  data() {
    return {
      valid: true,
      preCount: 0,
      isSkipped: [false, false, false, false, false, false, false],
      answer: [],
      answer2: [],
      lazy: false,
      rules: {
        required: (value) => !!value || '꼭 써주셔야 합니다',
        counter: (value) => value.length <= 20 || '최대 20 글자까지 해주세요',
        emailRules: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        },
      },
    }
  },
  methods: {
    ...mapMutations(['setLife']),
    ...mapActions(['submit']),
    getRule(inputType) {
      // console.log(inputType)

      const yearRegx = /^(19|20)[0-9]{2}$/
      const ageRegx = /^\d{2}$/
      const childRegx = /^[0-5]$/
      const emailRegx = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

      let val = []
      switch (inputType) {
        case 'year':
          val.push((v) => yearRegx.test(v) || '연도를 입력하세요')
          break
        case 'age':
          val.push((v) => ageRegx.test(v) || '나이를 입력하세요')
          break
        case 'children':
          val.push((v) => childRegx.test(v) || '최대 5명 숫자로 입력하세요')
          break
        default:
          return this.emailType ? [this.rules.required, this.rules.emailRules] : [this.rules.required]
      }
      return val
    },
    confirm() {
      const t = [
        {
          text: '현재부터 퇴직시점까지',
          value: this.answer[0],
        },
        {
          text: '퇴직이후부터 국민연금수령까지',
          value: this.answer[1],
        },
        {
          text: '국민연금 수령이후',
          value: this.answer[2],
        },
      ]
      t.push({ text: '그외 기타 재무이슈는', value: this.answer[3] })

      const payload = {
        id: '라이프-생애이슈',
        question: '2-5. 다음의 각 책임경감시점(exit) 단계별 나의 생애이슈는?',
        category: 'Life',
        type: 'custom',
        option: {},
        value: t,
      }
      this.setLife(payload)
      this.submit()
      this.$emit('next')
    },
    getPensionAge() {
      return this.getExit.filter((v) => v.name === '연금')[0].age
    },
  },
  computed: {
    ...mapState(['master', 'me', 'wife', 'children', 'parents', 'finance', 'currentYear', 'housePension', 'career', 'action', 'life']),
    ...mapGetters(['getExit', 'getFinanceGoalMoney', 'hasWife', 'getChildrenCount', 'getParentsCount']),
  },
}
</script>

<style></style>
